/* Keep the campaign route in sync with real kit choices; no store or cart writes. */
(function(){
'use strict';
var tiers=['essential','street','elite'];
function syncRoute(value){
 if(!tiers.includes(value))return;
 try{var u=new URL(location.href);if(u.searchParams.get('package')!==value){u.searchParams.set('package',value);history.replaceState(history.state,'',u.toString());}}catch(error){}
}
function restoreRoute(){
 if(!document.querySelector('[data-onair-complete-kits]'))return;
 var nav=performance.getEntriesByType('navigation')[0],query=new URLSearchParams(location.search);
 if(!['reload','back_forward'].includes(nav?.type)||query.get('source')==='setup-lab')return;
 try{var key='onair.v4.kit.'+String(window.Shopify?.theme?.id||'draft'),saved=JSON.parse(sessionStorage.getItem(key)||'null');if(saved?.values&&Date.now()-saved.time<28800000)syncRoute(saved.values.tier);}catch(error){}
}
document.addEventListener('change',function(event){var input=event.target;if(input.matches?.('input[name="tier"]')&&input.checked&&input.closest('[data-onair-complete-kits]'))syncRoute(input.value);},true);
function placeStyles(){var sheet=document.querySelector('link[href*="onair-v4-simplified.css"]');if(sheet&&document.querySelector('[data-onair-complete-kits]'))document.body.appendChild(sheet);}
function repairCompare(){
 document.querySelectorAll('.ov4-ready[data-onair-complete-kits]').forEach(function(root){
  if(root.dataset.ockCompareV4==='1')return;
  var old=root.querySelector('button.ock-compare-trigger');
  var panel=old&&document.getElementById(old.getAttribute('aria-controls'));
  if(!old||!panel||!root.contains(panel))return;
  var detail=document.createElement('details'),summary=document.createElement('summary'),label=document.createElement('strong'),sign=document.createElement('span');
  detail.className='ov4-compare';summary.className='ock-compare-trigger ov4-compare-summary';
  label.textContent='Compare 2V, 4V & V4 Elite';sign.textContent='+';sign.setAttribute('aria-hidden','true');
  summary.append(label,sign);summary.setAttribute('aria-controls',panel.id);summary.setAttribute('aria-expanded','false');
  old.replaceWith(detail);detail.append(summary,panel);panel.hidden=false;panel.style.display='block';
  function reflect(){summary.setAttribute('aria-expanded',String(detail.open));sign.textContent=detail.open?'−':'+';}
  summary.addEventListener('click',function(event){event.preventDefault();event.stopImmediatePropagation();detail.open=!detail.open;reflect();},true);
  detail.addEventListener('toggle',reflect);root.dataset.ockCompareV4='1';
 });
}
function ready(){placeStyles();restoreRoute();repairCompare();}
document.addEventListener('onair:v4:ready',function(){placeStyles();repairCompare();});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();
